/* eslint-disable no-unused-vars */

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './index.css';
import './gardenofpeace.css';
import './site.css';
import NavbarComponent from './componenets/NavbarComponent'; // Ensure this matches the actual file name
import Footer from './componenets/Footer';
import ScrollToTop from './componenets/ScrollToTop';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import PopUp from './PopUp';
import { AboutUs } from './AboutUs';
import { Mission } from './Mission';
import { BoardOfDirectors } from './BoardOfDirectors';
import { BurialEtiquette } from './BurialEtiquette';
import { JanazahProcess } from './JanazahProcess';
import { ContactUs } from './ContactUs';
import { WhyThisProject } from './WhyThisProject';
import { Gallery } from './Gallery';
import { FuneralServices } from './FuneralServices';
import { BurialRequest } from './BurialRequest';
import { DuaAndPrayers } from './DuaAndPrayers';
import { Donate } from './Donate';
import { Home } from './Home';
import { BurialPlot } from './BurialPlot';
// import { Presentation } from './Presentation';
import { QNA } from './QNA';
import { FundraisingInfo } from './FundraisingInfo';
import { Goals } from './Goals';
// import { Event } from './Event';
import { Training } from './Training';
import { Volunteering } from './Volunteering';

const App = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Show the modal when the component mounts
    setShowModal(true);
  }, []);

  const handleClose = () => {
    // Hide the modal
    setShowModal(false);
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <NavbarComponent />
      <ToastContainer />
      <PopUp show={showModal} onClose={handleClose} />

      {/* Routing Configuration */}
      <main id="main-content">
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/services" element={<Mission />} />
        <Route path="/boardofdirectors" element={<BoardOfDirectors />} />
        <Route path="/burialetiquette" element={<BurialEtiquette />} />
        <Route path="/janazahprocess" element={<JanazahProcess />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/whythisproject" element={<WhyThisProject />} />
        <Route path="/why-this-project" element={<Navigate to="/whythisproject" replace />} />
        <Route path="/QNA" element={<QNA />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/progressgoals2023" element={<Goals />} />
        <Route path="/progress" element={<Navigate to="/progressgoals2023" replace />} />
        <Route path="/funraising2023presentation" element={<FundraisingInfo />} />
        <Route path="/duaandprayers" element={<DuaAndPrayers />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/funeralservices" element={<FuneralServices />} />
        <Route path="/burialrequest" element={<BurialRequest />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/donatezellepaypal" element={<Navigate to="/donate" replace />} />
        <Route path="/donatecardpaypal" element={<Navigate to="/donate" replace />} />
        <Route path="/training" element={<Training />} />
        <Route path="/volunteering" element={<Volunteering />} />
        <Route path="/volunteer" element={<Navigate to="/volunteering" replace />} />
        <Route path="/burialplotpledgeform" element={<BurialPlot />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
